const EnumTipoComponents = {
  grupoFamiliar: 'grupo_familiar',
  tipoSolicitacao: 'template_tipo',
  formulario: 'formulario',
  encerramento: 'encerramento',
  termoDeUso: 'termos',
  identificacao: 'identificacao'
}

export default EnumTipoComponents
